import { Component, OnInit } from '@angular/core';
// import { AdalService } from './shared/services/adal.service';
import { LoaderService } from './shared/loader/loader.service';
import { UserService } from './Users/user.service';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from './shared/authentication/authentication.service';
import { Roles } from './Users/_models/user';
import { EnvService } from './shared/services/env.service';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  template: '<app-home></app-home>',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Deloitte Mobile Web PNS2.0';
  loadComponents: boolean = false;
  isIframe: boolean = false;
  loggedIn: boolean = false;
  loginInProgress: boolean = false;
  userRole: string = '';
  userName: string;
  getrolecontext: any;

  constructor(
    private msalService: MsalService,
    private loader: LoaderService,
    private userService: UserService,
    private authService: AuthenticationService,
    private router: Router
  ) {
    // Initialize frame check
    this.isIframe = window !== window.parent && !window.opener;
    // Use handleRedirectCallback for MSAL Angular v1.x
    this.msalService.handleRedirectCallback((authError, response) => {
      console.log('[MSAL] handleRedirectCallback called', { authError, response });
      if (authError) {
        this.loginInProgress = false;
        localStorage.setItem('authError', authError.errorMessage);
        console.error('Redirect Error: ', authError.errorMessage || authError);
        // Prompt login again if needed
        // Only retry login if not already in progress
        if (!this.loginInProgress) {
          console.log('[MSAL] Retrying login from handleRedirectCallback error');
          this.login();
        }
        return;
      }
      this.loginInProgress = false;
      this.processAccount();
      // Clear the hash so Angular router doesn't see /id_token
        window.location.hash = '';
    });
  }

  ngOnInit(): void {
    console.log('[AppComponent] ngOnInit called');
    if (!this.isIframe && !this.isRedirecting()) {
      // Only process account if session exists
      const account = this.msalService.getAccount();
      console.log('[AppComponent] ngOnInit account:', account);
      if (account) {
        this.processAccount();
      } else {
        // No session, prompt login
        this.login();
      }
    } else {
      this.loadComponents = true;
      this.loggedIn = true;
    }
  }

  processAccount() {
    const account = this.msalService.getAccount();
  console.log('[AppComponent] processAccount account:', account);
    const redirectFlag = sessionStorage.getItem('msalLoginRedirect');
  console.log('[AppComponent] processAccount redirectFlag:', redirectFlag);


    if (account){ this.userService.userEmail = account.userName;
      localStorage.setItem('userEmail', account.userName);
      console.log('Account found, login complete:', account);
      console.log(this.msalService.getCurrentConfiguration());
       
    }
else{
    // User is not authenticated
    this.loggedIn = false;
    this.loadComponents = false;

    // Only prompt login if not redirecting and no redirect flag
    if (!this.isRedirecting() && !redirectFlag) {
      sessionStorage.setItem('msalLoginRedirect', '1');
      this.login();
    }
    else if (redirectFlag) {
             console.error('Redirect loop detected. Not calling loginRedirect again.');
           } else {
             console.log('Already redirecting, not calling loginRedirect again.');
           }
  }
  }

  isRedirecting() {
    // Optionally implement logic to detect if in a redirect flow
    return false;
  }

  login(): void {
    if (!this.loginInProgress) {
      try {
        console.log('[MSAL] login() called');
        this.loginInProgress = true;
        this.msalService.loginRedirect({ scopes: ['user.read', 'openid', 'profile'] });
      } catch (error) {
        console.error('Login error:', error);
        this.loginInProgress = false;
      }
    } else {
      console.log('[MSAL] login() called but login is already in progress');
    }
  }

  loginInteractive(): void {
    if (!this.loginInProgress) {
      try {
        this.loginInProgress = true;
        this.msalService.loginRedirect({ scopes: ['user.read', 'openid', 'profile'] });
      } catch (error) {
        console.error('Interactive login error:', error);
        this.loginInProgress = false;
      }
    }
  }

  logout(): void {
    try {
      this.loginInProgress = false;
      this.msalService.logout();
      this.loggedIn = false;
      this.loadComponents = false;
      localStorage.clear();
    } catch (error) {
      console.error('Logout error:', error);
    }
  }
  }

  // getUserProfile(userName)
  // {
  //   this.userService.getUserInfo("userProfile",userName,1).subscribe((value:any) => { 
  //     var userProfile = value.data;
  //     this.authService.resetUser();
  //   // this.authService.setUser(null,0);
  //     let loggedInUserRoles = [];
  //     let allTenantsAssigned =[];
  //     let allAppsAssigned=[];
  //     if(userProfile.systemRole)
  //     {
  //       if(userProfile.systemRole.systemRoleType==0)
  //       loggedInUserRoles.push(Roles.SystemAdmin);
  //     else if(userProfile.systemRole.systemRoleType==1)
  //       loggedInUserRoles.push(Roles.SystemReader);
  //     }
  //      if(userProfile.tenantRoles && userProfile.tenantRoles.length>0)
  //     {
  //       userProfile.tenantRoles.forEach(element => {
  //         if(element.tenantRoleType==0){
  //         loggedInUserRoles.push(Roles.TenantOwner);
  //         allTenantsAssigned.push(element.tenant.id);
  //         }
  //         if(element.tenantRoleType==1){
  //         loggedInUserRoles.push(Roles.TenantReader);
  //         allTenantsAssigned.push(element.tenant.id);
  //         }
  //       });
  //     }
  //      if(userProfile.applicationRoles && userProfile.applicationRoles.length>0)
  //     {
  //       userProfile.applicationRoles.forEach(item => {
  //         item.associatedApplicationRoles.forEach(element => {
  //           if(element.applicationRoleType==0){
  //           loggedInUserRoles.push(Roles.AppOwner);
  //           allAppsAssigned.push(element.application.id);
  //           }
  //           if(element.applicationRoleType==1){
  //           loggedInUserRoles.push(Roles.AppReader);
  //           allAppsAssigned.push(element.application.id);
  //           }
  //           if(element.applicationRoleType==2){
  //           loggedInUserRoles.push(Roles.AppNotificationOwner);
  //           allAppsAssigned.push(element.application.id);
  //           }
  //         });
  //       });
  //     }
  //     loggedInUserRoles = loggedInUserRoles.filter((el, i, a) => i === a.indexOf(el))
  //     localStorage.setItem('loggedInUserRoles',JSON.stringify(loggedInUserRoles));
  //     this.authService.setUser(userProfile,loggedInUserRoles);
  //     this.authService.setTenantIds(allTenantsAssigned);
  //     this.authService.setApplicationIds(allAppsAssigned);
  //    this.loadComponents = true;

  //    //omniture call
  //    if(dataLayer!==undefined){
  //     dataLayer.pageInfo.pageName='app load';
  //     dataLayer.pageInfo.userID=userProfile.userId;
  //     dataLayer.pageInfo.role=loggedInUserRoles;
  //     dataLayer.pageInfo.module="app load";
  //     }

  //    this.router.navigate(["dashboard"]);
  //   });
  // }


